declare global {
  type VoteType = typeof VoteType[keyof typeof VoteType];
}

export const VoteType = {
  Upvote: 1,
  Downvote: -1,
  Novote: 0,
} as const;
